var bookshelf = require("../index-extended"); // ???: ..

module.exports = bookshelf.model("GeneralSetting", {
  tableName: "general_setting",
});
